/* unplugin-vue-components disabled */import { render } from "./pagination.vue?vue&type=template&id=7db3df9e&scoped=true&ts=true"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"

import "./pagination.vue?vue&type=style&index=0&id=7db3df9e&scoped=true&lang=css"
import "./pagination.vue?vue&type=style&index=1&id=7db3df9e&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db3df9e"],['__file',"src/baseui/pagination/pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7db3df9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7db3df9e', __exports__)) {
    console.log('reload')
    api.reload('7db3df9e', __exports__)
  }
  
  module.hot.accept("./pagination.vue?vue&type=template&id=7db3df9e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7db3df9e', render)
  })

}


export default __exports__